import { Medscape } from './medscape';
import { StreamingVideoPlayer } from './streaming-video-player';
import { PlaylistVideoPlayer } from './playlist-video-player';
import { MedscapeAudioPlayer } from './medscape-audio-player';
import { AMP, akamai } from './globals';
import { AmpVideoConfig } from './configs/amp-video-config';

Medscape.modules = Object.assign({},Medscape.modules,{
	StreamingVideoPlayer,
	PlaylistVideoPlayer,
	MedscapeAudioPlayer
})

export { StreamingVideoPlayer }
export { PlaylistVideoPlayer }
export { MedscapeAudioPlayer }
export { AMP }
export { akamai }
export { AmpVideoConfig }
